export enum FolioStatusEnum {
  DRAFT = 'DRAFT',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PAID = 'PAID',
  VOID = 'VOID',
}

